import AvisHighTechLogo from './logo'
import {selectionTopStylesFR} from './styles'

const baseConfig = {
  domainName: 'selectiontop' as const,
  domainType: 'eu' as const,
  siteName: 'Selection Top',
  logo: <AvisHighTechLogo className="size-8 shrink-0 tablet:size-6" locale="fr" />,
  favicon: '/favicons/selectiontop.png',
}

const localeConfigs = {
  fr: {
    measurementId: 'G-23RDBV5WBS',
    camelCaseUrl: 'SelectionTop.fr',
    title: (category: string, _count: string) => `Sélection des Meilleurs ${category} et Avis Utiles - SelectionTop`,
    description: (_category?: string, _count?: string) =>
      `Profitez de nos classements détaillés, comparatifs précis et avis pertinents pour faire vos achats en ligne de façon éclairée et économique.`,
    styles: selectionTopStylesFR,
  },
}

export const createConfig = (locale: string = 'fr') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.fr
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
